/**
 * Offene Vertragsanpassung beim „Profil speichern" mitnehmen.
 *
 * Die Vertragsanpassung (09 · Vertrag & Preise) ist ein eigener Datensatz mit
 * eigenem Knopf — wer nur einen neuen Vertragspreis einträgt und unten auf
 * „Profil speichern" klickt, hätte sonst nichts gespeichert. Der
 * PbVertragBlock meldet deshalb hier an, wie seine noch nicht gespeicherte
 * Eingabe zu speichern ist; PbProfileEdit ruft das nach dem Profil-Save auf.
 */

/** Speichert eine offene Eingabe; tut nichts, wenn es keine gibt. Wirft bei Fehler. */
type Flush = () => Promise<void>;

const registry = new Map<number, Flush>();

/** Meldet den Speicher-Callback für einen User an; Rückgabe = Abmelden. */
export function registerPendingVertrag(userId: number, flush: Flush): () => void {
  registry.set(userId, flush);
  return () => {
    if (registry.get(userId) === flush) registry.delete(userId);
  };
}

/** Speichert die offene Vertragsanpassung des Users, falls eine angemeldet ist. */
export async function flushPendingVertrag(userId: number): Promise<void> {
  await registry.get(userId)?.();
}
